import { Button, Descriptions, Drawer } from "@arco-design/web-react";
import { useCallback, useEffect, useLayoutEffect, useRef } from "react";
import { feeAdjustmentSpecUnit, fulfillmentResourceTypeLabel, fulfillmentServiceProviderName, isReadableSupplierBusinessName } from "../service";
import { confirmationDecimalInput, formatConfirmationAmount } from "../service/confirmationDecimalDisplay";
import type { FulfillmentOrderLine } from "../types";

type Props = { line: FulfillmentOrderLine | null; onClose: () => void };

/** 查看确认行已保存事实；此入口不持有表单、写入回调或主体查询。 */
export function FulfillmentOrderLineDetailDrawer({ line, onClose }: Props) {
  const trigger = useRef<HTMLElement | null>(null);
  const restoreFocus = useCallback(() => { if (trigger.current?.isConnected) trigger.current.focus(); }, []);
  useLayoutEffect(() => {
    if (line && document.activeElement instanceof HTMLElement) trigger.current = document.activeElement;
    if (!line) restoreFocus();
  }, [line, restoreFocus]);
  useEffect(() => () => restoreFocus(), [restoreFocus]);
  const text = (value?: string | null) => value?.trim() || "—";
  const supplierName = line ? fulfillmentServiceProviderName(line) : null;
  return <Drawer
    visible={Boolean(line)} width={560} style={{ maxWidth: "100vw" }} focusLock escToExit unmountOnExit
    title={line ? `查看确认行 · #${line.lineNo} · ${line.itemNameSnapshot}` : "查看确认行"}
    onCancel={onClose} afterClose={restoreFocus}
    afterOpen={() => document.querySelector<HTMLElement>(".fulfillment-order-line-detail .arco-drawer-scroll")?.focus()}
    className="fulfillment-order-line-detail"
    footer={<Button onClick={onClose}>关闭</Button>}
  >
    {line && <section aria-label="确认行明细"><Descriptions column={1} border data={[
      { label: "资源类型", value: fulfillmentResourceTypeLabel(line.resourceType) },
      { label: "服务项目", value: line.itemNameSnapshot },
      { label: "规格", value: text(line.itemSpecSnapshot) },
      { label: "服务日期", value: (line.serviceDates?.length ? line.serviceDates : [line.serviceDateFrom, line.serviceDateTo].filter(Boolean)).join("、") || "—" },
      { label: "旅客角色", value: text(line.travelerRole) },
      { label: "计费依据", value: `${confirmationDecimalInput(line.quantity)} ${line.unit} × ${confirmationDecimalInput(line.billingCount)} ${feeAdjustmentSpecUnit(line.resourceType)}` },
      { label: "单价", value: formatConfirmationAmount(line.unitPriceAmount) },
      { label: "确认金额", value: formatConfirmationAmount(line.amount) },
      { label: "服务主体", value: supplierName && !isReadableSupplierBusinessName(supplierName) ? "待重新选择" : text(supplierName) },
      { label: "结算主体", value: text(line.settlementSupplierName) },
      { label: "备注", value: text(line.remark) },
    ]} /></section>}
  </Drawer>;
}
